import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* eslint-disable no-undef */
import { useState, useEffect } from 'react';

/**
 * Credit to a StackOverflow answer for the bulk of this hook.  It has been modified
 * to fit our lint rules.
 * https://stackoverflow.com/questions/36862334/get-viewport-window-height-in-reactjs
 */

const getWindowDimensions = () => {
  const _window = window,
    width = _window.innerWidth,
    height = _window.innerHeight;
  return {
    width,
    height
  };
};
const useWindowDimensions = () => {
  const _useState = useState(getWindowDimensions()),
    _useState2 = _slicedToArray(_useState, 2),
    windowDimensions = _useState2[0],
    setWindowDimensions = _useState2[1];
  useEffect(() => {
    const handleResize = () => {
      setWindowDimensions(getWindowDimensions());
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return windowDimensions;
};
export default useWindowDimensions;